<template>
  <base-content
    :data="data"
    :index="index"
    view="list"
  >
    <template #card-header>
      <partial-title :title="title" :link="link" />
    </template>

    <template #card-body>
      <partial-description v-if="description"
        :description="description"
        :isLoading="highlightsLoading">
      </partial-description>

      <ul v-if="!isEmpty(matches)" :class="{ 'mt-2': description }">
        <matches :matches="matches" view="list" />
      </ul>
    </template>

    <template #card-footer>
      <partial-research-group v-if="!isEmpty(researchGroup)"
        :researchGroup="researchGroup"
        :highlights="highlights"
        :lineClamp="1">
      </partial-research-group>

      <partial-organisations v-if="researchGroup && !isEmpty(researchGroup.organisations)"
        :isWithCount="false"
        :isTextWithCountry="true"
        :organisations="researchGroup.organisations"
        :lineClamp="1">
      </partial-organisations>
    </template>

    <template #card-actions>
      <slot name="actions"></slot>
    </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/researchTopic'

import BaseContent from '@/components/search/results/BaseContent'
import PartialDescription from '@/components/search/results/partials/Description'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialResearchGroup from '@/components/search/results/partials/ResearchGroup'
import Matches from '@/components/search/results/partials/Matches'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'researchTopicResultList',
  mixins: [processing],
  components: {
    PartialTitle,
    PartialDescription,
    PartialResearchGroup,
    Matches,
    BaseContent,
    PartialOrganisations
  }
}
</script>
